import { render, staticRenderFns } from "./CrmAttr.vue?vue&type=template&id=79f4d90c&scoped=true"
import script from "./CrmAttr.vue?vue&type=script&lang=js"
export * from "./CrmAttr.vue?vue&type=script&lang=js"
import style0 from "./CrmAttr.vue?vue&type=style&index=0&id=79f4d90c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f4d90c",
  null
  
)

export default component.exports